import React from 'react';

import AppWrapper from 'components/apps/AppWrapper';
import MultiCategoriesMultiDivisionsEditable from 'components/riskRegister/sharedResourceNotices/components/MultiCategoriesMultiDivisionsEditable';
import MultiCategoriesMultiDivisionsNonEditable from 'components/riskRegister/sharedResourceNotices/components/MultiCategoriesMultiDivisionsNonEditable';
import MultiCategoriesSingleDivisionEditable from 'components/riskRegister/sharedResourceNotices/components/MultiCategoriesSingleDivisionEditable';
import MultiDivisionCategoryNotice from 'components/riskRegister/sharedResourceNotices/components/MultiDivisionCategoryNotice';
import SingleCategoryMultiDivisionsEditable from 'components/riskRegister/sharedResourceNotices/components/SingleCategoryMultiDivisionsEditable';
import SingleCategoryMultiDivisionsNonEditable from 'components/riskRegister/sharedResourceNotices/components/SingleCategoryMultiDivisionsNonEditable';

export default function EntryPoint({ contextProps, wrappedProps }) {
  const { componentName } = wrappedProps;

  const Component = {
    MultiCategoriesMultiDivisionsEditable,
    MultiCategoriesMultiDivisionsNonEditable,
    MultiCategoriesSingleDivisionEditable,
    MultiDivisionCategoryNotice,
    SingleCategoryMultiDivisionsEditable,
    SingleCategoryMultiDivisionsNonEditable,
  }[componentName];

  return (
    <AppWrapper {...contextProps}>
      <Component {...wrappedProps} />
    </AppWrapper>
  );
}
